import { CommonTimeSlot, Day, QuickOption } from '@/containers/CustomerJourneySetup/context/types';
import { Sunrise, Sunset, Sun, Moon } from 'lucide-react';

export const days: Day[] = [
  { key: 'monday', label: 'Lunes', shortLabel: 'Lun' },
  { key: 'tuesday', label: 'Martes', shortLabel: 'Mar' },
  { key: 'wednesday', label: 'Miércoles', shortLabel: 'Mié' },
  { key: 'thursday', label: 'Jueves', shortLabel: 'Jue' },
  { key: 'friday', label: 'Viernes', shortLabel: 'Vie' },
  { key: 'saturday', label: 'Sábado', shortLabel: 'Sáb' },
  { key: 'sunday', label: 'Domingo', shortLabel: 'Dom' }
];

export const quickOptions: QuickOption[] = [
  {
    id: 'weekdays',
    label: 'Lunes a viernes',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
  },
  {
    id: 'alldays',
    label: 'Todos los días',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
  }
];

export const commonTimeSlots: CommonTimeSlot[] = [
  { label: 'Mañana', start: '09:00', end: '13:00', icon: <Sunrise className="h-4 w-4" /> },
  { label: 'Tarde', start: '14:00', end: '18:00', icon: <Sunset className="h-4 w-4" /> },
  { label: 'Jornada completa', start: '09:00', end: '18:00', icon: <Sun className="h-4 w-4" /> },
  { label: 'Noche', start: '19:00', end: '23:00', icon: <Moon className="h-4 w-4" /> }
];
